import { observer } from "mobx-react";
import React, { useRef, useState, useEffect, useMemo } from "react";
import ArrowButton from "../ArrowButton";
import AToZ from "../AToZ";
import empty from "../../assets/images/svg/modalEmpty.svg";

import SearchButton from "../SearchButton/SearchButton";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import OverflowingText from "../OverflowingText/OverflowingText";

const ModalFamilyWithCheckboxes = observer(
  ({
    selectedMemberForReports,
    setSelectedMemberForReports,
    onClose,
    showResetAndSubmit,
    searchBarWidth,
    isSort,
    setSort,
  }) => {
    const [start, setStart] = useState(false);
    const [search, setSearch] = useState("");
    const [selectedLocal] = useState("0");

    const buttonsRef = useRef(null);
    const searchRef = useRef(null);
    const divRef = useRef(null);
    const familyRef = useRef(null);

    const getDefaultImage = (name) => {
      return <div className="profileImageDefault2">{name?.[0]}</div>;
    };

    const filteredMembers = UserStore.currentFamilyMembers?.filter((member) => {
      return member.full_name.toLowerCase().includes(search.toLowerCase());
    });

    const resetClick = () => {};

    const getClasses = (condition, index, length) => {
      if (start && index + 1 === length) {
      }
      return !condition ? "member_body" : "member_body members_order";
    };

    const handleSubmit = () => {
      if (selectedLocal === 0) {
        UserStore.setClientOrFamily("fam");
        PerformanceStore.setFamOrClient({ name: "fam", id: "0" });
        UserStore.setUserData({ allMembers: true });
      } else {
        UserStore.setClientOrFamily("client");
        PerformanceStore.setFamOrClient({
          name: "client",
          id: selectedLocal,
        });
        UserStore.setUserData(
          UserStore.currentFamilyMembers?.find(
            (data) => data.user_id === selectedLocal,
          ),
        );
        UserStore.setUserData({ allMembers: false });
      }
      onClose();
    };

    const handleRef = (type) => {
      type === "hide"
        ? (searchRef.current.style.display = "none")
        : (searchRef.current.style.display = "flex");
    };

    useEffect(() => {
      setStart(true);
    }, []);

    const highlighter = (name) => {
      if (name.toLowerCase().includes(search.toLowerCase()) && search) {
        let regex = new RegExp(`(${search})`, "gi");
        const parts = name.split(regex);
        return parts.map((part, index) =>
          part.match(regex) ? <span className="highlight">{part}</span> : part,
        );
      }
      return name;
    };

    const handleMembersChange = (changedMembers) => {
      if (changedMembers === "All") {
        if (
          selectedMemberForReports === "All" ||
          UserStore.currentFamilyMembers
            ?.map((familyMember) =>
              selectedMemberForReports.find(
                (member) => member?.user_id === familyMember?.user_id,
              ),
            )
            ?.every(Boolean)
        ) {
          setSelectedMemberForReports([]);
        } else {
          setSelectedMemberForReports(
            UserStore.currentFamilyMembers?.map((familyMember) => familyMember),
          );
        }
      } else {
        if (selectedMemberForReports === "All") {
          setSelectedMemberForReports(
            UserStore.currentFamilyMembers
              ?.map((familyMember) => familyMember)
              .filter(
                (eachMember) => eachMember?.user_id !== changedMembers?.user_id,
              ),
          );
        } else {
          if (
            selectedMemberForReports
              ?.map((eachMember) => eachMember?.user_id)
              ?.includes(changedMembers?.user_id)
          ) {
            setSelectedMemberForReports((prevState) => {
              return prevState.filter(
                (eachMember) => eachMember?.user_id !== changedMembers.user_id,
              );
            });
          } else {
            setSelectedMemberForReports([
              ...selectedMemberForReports,
              changedMembers,
            ]);
          }
        }
      }
    };

    const sortedArray = useMemo(() => {
      let sortedData = filteredMembers;
      if (sortedData && isSort === "asc") {
        sortedData = [...sortedData]?.sort();
      } else if (sortedData && isSort === "desc") {
        sortedData = [...sortedData]?.sort((a, b) => {
          return b.full_name.localeCompare(a.full_name);
        });
      }
      return sortedData;
    }, [filteredMembers, isSort]);

    return (
      <>
        <div className="family_modal">
          <div ref={buttonsRef} className="modal_search">
            <div ref={searchRef} className="atozref">
              <div
                onClick={() => {
                  switch (isSort) {
                    case "asc":
                      setSort("desc");
                      break;
                    case "desc":
                      setSort("asc");
                      break;
                    default:
                      setSort("desc");
                      break;
                  }
                }}
                className="familiies_a_to_z"
              >
                <AToZ isSort={isSort} className="aToZclassName" />
              </div>
            </div>
            <div className="modal_search_ip">
              <SearchButton
                type={"search"}
                search={search}
                setSearch={(data) => setSearch(data)}
                width={searchBarWidth || "710px"}
                handleRef={(type) => handleRef(type)}
                className="modal_family_search_button"
              />
            </div>
          </div>

          {sortedArray?.length ? (
            <div ref={familyRef} className="family">
              <div className="all_members">
                {
                  <div
                    className="member_title_all"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleMembersChange("All")}
                  >
                    <div className="each_checkbox_wrapper">
                      <input
                        id={"all-family-members"}
                        checked={
                          selectedMemberForReports === "All" ||
                          UserStore.currentFamilyMembers
                            ?.map((familyMember) =>
                              selectedMemberForReports.find(
                                (member) =>
                                  member?.user_id === familyMember?.user_id,
                              ),
                            )
                            ?.every(Boolean)
                        }
                        onChange={() => handleMembersChange("All")}
                        type="checkbox"
                        className="checkbox"
                      />
                      <label
                        className="member_title cursor"
                        htmlFor="all-family-members"
                      >
                        All Members{" "}
                      </label>
                    </div>
                  </div>
                }
                {sortedArray?.map((data, index, currArray) => (
                  <div
                    style={{ cursor: "pointer" }}
                    key={index}
                    ref={divRef}
                    className={getClasses(
                      data.isprimary,
                      index,
                      currArray.length,
                    )}
                    onClick={() => handleMembersChange(data)}
                  >
                    <div className="each_checkbox_wrapper">
                      <input
                        id={data.full_name}
                        checked={
                          selectedMemberForReports === "All" ||
                          selectedMemberForReports.find(
                            (member) => member?.user_id === data?.user_id,
                          )
                            ? true
                            : false
                        }
                        aria-label={data.full_name}
                        onChange={() => handleMembersChange(data)}
                        type="checkbox"
                        className="checkbox"
                      />
                      <label
                        className="checkbox_label cursor"
                        htmlFor={data.full_name}
                      >
                        {data?.name}
                      </label>
                    </div>
                    <div>
                      {data.profile_pic &&
                      UserStore.currentFamilyMembersImages?.[data.user_id] ? (
                        <img
                          className="member_profile"
                          src={
                            UserStore.currentFamilyMembersImages?.[data.user_id]
                          }
                          alt=""
                        />
                      ) : (
                        getDefaultImage(data.full_name)
                      )}
                    </div>
                    <div
                      className="member_name"
                      style={{ width: "calc(100% - 268px)" }}
                    >
                      {false ? (
                        <OverflowingText
                          text={
                            true
                              ? "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor"
                              : highlighter(data.full_name)
                          }
                          textClassName="member_name"
                          width={"calc(100% - 268px)"}
                          position="left"
                          tooltipWidth={230}
                        />
                      ) : (
                        highlighter(data.full_name)
                      )}
                    </div>
                    {data.isprimary && (
                      <span className="ismemberprimary">primary</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: "1px solid",
                margin: "auto",
                width: "90%",
                padding: "60px",
                marginTop: "32px",
                justifyContent: "center",
                borderRadius: "20px",
                height: "300px",
                borderColor: "#DDE2EB",
                textAlign: "center",
              }}
            >
              <img
                style={{ width: "fit-content", marginBottom: "32px" }}
                src={empty}
                alt=""
              />
              <p
                style={{
                  marginBottom: "15px",
                  fontFamily: "Encode Sans",
                  fontWeight: "500",
                  fontSize: "18px",
                }}
              >
                Family Member not found
              </p>
              <p>The name “{search}” did not match any Family member</p>
            </div>
          )}

          {showResetAndSubmit !== false && !!sortedArray?.length && (
            <div className="modal_buttons">
              <span onClick={resetClick} className="modal_reset">
                Reset
              </span>
              <ArrowButton
                type={"next"}
                label={"Apply"}
                onClick={handleSubmit}
              />
            </div>
          )}
        </div>
      </>
    );
  },
);

export default ModalFamilyWithCheckboxes;
